export const headDataUsers = {
  edit: "",
  dscnomape: "Nombre completo",
  email: "Correo",
  perfil: "Perfil",
  status: "Estado",
};

export const headDataDocuments = {
  id: "",
  broadcast: "Emisión",
  docType: "Tipo de Documento",
  docNumber: "Número Documento",
  clientDoc: "Doc. Proveedor",
  clientName: "Nombre Proveedor",
  currency: "Moneda",
  amount: "Importe",
  taxes: "Impuestos",
  total: "Total",
  reception: "Recepción",
  sunatStatus: "Estado Sunat",
  actions: "Archivos",
};
